export default class DataSetColDecimalEditor
{
	name;
    label;
    visible = true;
    helpText = null;
    displayLength = 20;
    alignment = "Center";
    showZero = false;
    thousandSeperator = false ;
    numOfDecimals = 2;
    displayDecimals = 0;
    currencyType = 'None';
    currencySymbol = 'None';
    percentage = false;
    type = "Decimal";
}


// WEBPACK FOOTER //
// ./src/universalView/dataSet/DataSetColDecimalEditor.js